module.exports = __webpack_public_path__ + "img/leila-popovici.87cced38.png";